/* eslint-disable @typescript-eslint/no-explicit-any */
import posthog from 'posthog-js';
import { IAnalyticsProvider } from './AnalyticsService';

class PosthogWebProvider implements IAnalyticsProvider {
  private client: any | undefined;

  async init(): Promise<void> {
    const apiKey = process.env.REACT_APP_POSTHOG_API_KEY;
    // Without a token, posthog.init() returns an uninitialised global stub that
    // is truthy (so `this.client?.` guards don't help) but throws on the first
    // call that touches internals (e.g. group()/identify()). Skip init entirely
    // when no key is configured so analytics is cleanly disabled instead.
    if (this.client === undefined && apiKey) {
      this.client = posthog.init(apiKey, {
        api_host: 'https://app.posthog.com',
        cross_subdomain_cookie: false,
      });
    }
  }

  identify(userId: string, properties: Record<string, any>): void {
    this.client?.identify(userId, properties);
  }

  group(
    groupType: string,
    groupId: string,
    properties: Record<string, any>,
  ): void {
    this.client?.group(groupType, groupId, properties);
  }

  capture(event: string, properties?: Record<string, any>): void {
    this.client?.capture(event, properties || {});
  }

  async isFeatureEnabled(feature: string): Promise<boolean> {
    return await new Promise(resolve => {
      if (this.client)
        if (this.client?.isFeatureEnabled(feature)) {
          // feature flags should be available at this point
          resolve(true);
        } else resolve(false);
      else resolve(false);
    });
  }

  async getAllFeatureFlags(): Promise<any> {
    return;
  }

  startSessionRecording(): void {
    this.client?.startSessionRecording();
  }

  stopSessionRecording(): void {
    this.client?.stopSessionRecording();
  }

  reset(): void {
    this.client?.reset();
  }
}

export default PosthogWebProvider;
